import { DocumentNode } from 'apollo-link';
import gql from 'graphql-tag';
import { DatasourcesDisplayGridRowDataFragmentGql } from './DatasourcesDisplayGridRowDataFragmentGql';

export const VirtualConnectionTableDownstreamDatasourcesFilteredByColumnQueryGql: DocumentNode = gql`
query VirtualConnectionTableDownstreamDatasourcesFilteredByColumnQuery(
  $vizportalUrlId: String!,
  $selectedColumnId: ID!,
  $first: Int!,
  $offset: Int!,
  $orderBy: PublishedDatasourceSortOrder!
) {
  virtualConnectionTables(filter: { vizportalUrlId: $vizportalUrlId }) {
    columnsConnection(filter: { id: $selectedColumnId }) {
      nodes {
        downstreamDatasourcesConnection(first: $first, offset: $offset, orderBy: $orderBy) {
          totalCount
          nodes {
            ...DatasourcesDisplayGridRowDataFragment
          }
        }
      }
    }
  }
}
${DatasourcesDisplayGridRowDataFragmentGql}
`;
